import classnames from 'classnames'
import Icon from '@components/Icon'
import Button from '@components/Button'
import styles from './styles.module.scss'

export const CardSectionButton = ({
    onClick,
    value,
    additionalValue,
    description,
    isSpecialValue,
    isSelected,
    className,
    children,
    isCapitalizeCase,
    extraDesc,
}) => (
    <Button
        onClick={onClick}
        btnStyle="outline"
        type="button"
        className={classnames('d-flex', 'flex-column', 'ml-2', 'p-2', styles.sectionButton, {
            [styles.selected]: isSelected,
            [styles.selectedSpecial]: isSpecialValue,
            [className]: !!className,
        })}>
        <div className={`d-flex align-items-center ${children && 'justify-content-center'}`}>
            {children ? (
                children
            ) : (
                <>
                    {' '}
                    <span className="font-weight-bold text-large text-left">{value}</span>
                    {isSelected && (
                        <Icon
                            className={classnames('ml-2', styles.checkIcon, {
                                [styles.isSpecial]: isSpecialValue,
                            })}
                            type="checked_new"
                        />
                    )}
                </>
            )}
        </div>
        {additionalValue && (
            <span className={`text-small text-left text-lowercase font-italic`}>{additionalValue}</span>
        )}
        <span
            className={`text-light text-left text-base ${isCapitalizeCase ? styles.textTransformUnset : 'text-lowercase'}`}>
            {description}
        </span>
        {extraDesc && <span className={`text-light text-left text-base ${styles.extraDesc}`}>{extraDesc}</span>}
    </Button>
)

CardSectionButton.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.string.isRequired,
    description: PropTypes.string,
    isSpecialValue: PropTypes.bool,
    isSelected: PropTypes.bool,
}
